export default {
  setWorkflowCurrentStep(state, val) {
    state.newGI.workflowCurrentStep = val.currentStep
  },

  setPolicyTypeList(state, val) {
    state.newGI.policyTypeList = val.list
  },

  setCurrentStepFieldValue(state, val) {
    state.newGI.fields[val.name] = val.value
  },

  setCurrentStepFieldStatus(state, val) {
    state.newGI.fields[val.name].disabled = val.disabled
    state.newGI.fields[val.name].hide = val.hide
  },

  setGIProductFields(state, val) {
    state.newGI.policyFields = val.fieldList
  },

  setGIPolicyID(state, val) {
    state.newGI.policyID = val.policyID
  },

  setPaymentMethodID(state, val) {
    state.newGI.paymentMethodID = val.paymentMethodID
  },

  setGITypeID(state, val) {
    state.newGI.giTypeID = val.giTypeID
  },

  setSelections(state, val) {
    state.selections = val.selections;
  }

}



// WEBPACK FOOTER //
// ./src/My/store/mutations.js